/**
 * Sentry `denyUrls` allowlist for the pro admin frontend. Separated from
 * `sentry-init.ts` (which reads `import.meta.env.VITE_SENTRY_DSN` at
 * call time) so this array stays trivially unit-testable.
 *
 * Browser-extension origins: an extension injecting a content script
 * into the admin dashboard has its own thrown errors attributed to us
 * by `@sentry/react`'s `browserApiErrors` integration, the same way any
 * third-party `addEventListener` throw is. `cdn.gpteng.co` is the
 * Lovable/GPT-Engineer platform script pro loads in `index.html`
 * (`<script src="https://cdn.gpteng.co/gptengineer.js">`) — third-party
 * code we don't own and can't fix.
 */
export const SENTRY_DENY_URLS: RegExp[] = [
  /^chrome-extension:\/\//,
  /^moz-extension:\/\//,
  /^safari-extension:\/\//,
  /^safari-web-extension:\/\//,
  /cdn\.gpteng\.co/,
];
